import {APP_REPORT_CENTER_API_ENDPOINT} from "../../../constants/api_urls";

export const REPORT_TYPE_HEADER_LABELS = {
  PERFORMANCE_GLOBAL: 'Performance global',
  GLOBAL_MARKET: 'Global Market',
  DISPLAY_ADS: 'Performance Display Ads',
  AI_CONNECT: 'AI Connect',
  RESERVATIONS: 'Reservations',
  BILLING: 'Billing',
  PERFORMANCE_GOOGLE_FBL:'Google FBL',
  PERFORMANCE_METASEARCH:'Performance metasearch',
  PERFORMANCE_PMAX:'Google PMax',
  SP_FUNNEL_TRIPADVISOR:'SP Funnel Tripadvisor',
  PRICE_COMPETITIVENESS:'Price Competitiveness',
  PERFORMANCE_MARKET_PMAX:'Google PMax Market',
  PERFORMANCE_GOOGLE_MISSED_OPPORTUNITY:'Google Missed Opportunity',
  METASEARCH_PACING: 'Metasearch pacing',
  META_HOTEL_ADS: 'Meta Hotel Ads',
  PERFORMANCE_BING_PPA: 'Bing Hotel Ads PPA',
};

export const DELIVERY_FREQUENCY_LABELS = {
  ONCE:'Once',
  DAILY_TIME: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
};

export const STATUS_LABELS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Paused',
  COMPLETED: 'Completed',
  RUNNING:'Active'
};

export const REPORT_TYPE_URLS = {
    PERFORMANCE_GLOBAL: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/performance-global/details",
    GLOBAL_MARKET: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/global-market/details",
    DISPLAY_ADS: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/display-ads/details",
    AI_CONNECT: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/ai-connect/details",
    PERFORMANCE_GOOGLE_FBL: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/performance-google-fbl/details",
    PERFORMANCE_METASEARCH:APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/performance-metasearch/details",
    PERFORMANCE_PMAX: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/performance-pmax/details",
    META_HOTEL_ADS: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/meta-hotel-ads/details",
    SP_FUNNEL_TRIPADVISOR: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/sp-funnel-trip-advisor/details",
    PRICE_COMPETITIVENESS: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/price-competitiveness/details",
    PERFORMANCE_MARKET_PMAX: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/performance-market-google-pmax/details",
    BILLING: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/billing/details",
    RESERVATIONS: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/reservation/details",
    PERFORMANCE_GOOGLE_MISSED_OPPORTUNITY: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/performance-google-missed-opportunity/details",
    METASEARCH_PACING: APP_REPORT_CENTER_API_ENDPOINT+"/api/reports/metasearch-pacing/details",
};

export const REPORT_TYPE_LISTING_TITLE = {
  PERFORMANCE_GLOBAL: "Performance global",
  DISPLAY_ADS: "Performance Display Ads",
  GLOBAL_MARKET: "Global Market",
  AI_CONNECT: "AI Connect",
  PERFORMANCE_GOOGLE_FBL: "Performance Google FBL",
  PERFORMANCE_METASEARCH: "Performance metasearch",
  PERFORMANCE_PMAX: "Performance PMax for Travel",
  META_HOTEL_ADS: "Meta Hotel Ads",
  SP_FUNNEL_TRIPADVISOR: "Tripadvisor Sp Funnel",
  PRICE_COMPETITIVENESS: "Price Competitiveness",
  PERFORMANCE_MARKET_PMAX: "Performance Market - PMax for Travel",
  BILLING: "Billing",
  RESERVATIONS: "Reservations ",
  PERFORMANCE_GOOGLE_MISSED_OPPORTUNITY: "Performance Missed Opportunity",
  METASEARCH_PACING: "Metasearch Pacing",
};